import { RDS_DATA_DICTIONARY_ALL_COLUMNS } from './column.model';

export const RDS_DICTIONARY_TABLE_MIN_COL_WIDTH = 50;
export const RDS_DICTIONARY_TABLE_MAX_COL_WIDTH = 400;
export const RDS_DICTIONARY_DEFAULT_COLUMNS = RDS_DATA_DICTIONARY_ALL_COLUMNS.slice(0, 8);
